import React, { createContext, useCallback, useEffect, useRef, useState } from 'react';
import { Client } from '../../modules/conversations';
import { Conversation } from '@twilio/conversations';
import { Message } from '@twilio/conversations';
import useVideoContext from '../../../hooks/useVideoContext/useVideoContext';

type ChatContextType = {
  isChatWindowOpen: boolean;
  setIsChatWindowOpen: (isChatWindowOpen: boolean) => void;
  connect: (token: string) => void;
  disconnect: () => void;
  hasUnreadMessages: boolean;
  messages: Message[];
  conversation: Conversation | null;
};

export const ChatContext = createContext<ChatContextType>(null!);

export const ChatProvider: React.FC = ({ children }) => {
  const { room, onError } = useVideoContext();
  const isChatWindowOpenRef = useRef(false);
  const [isChatWindowOpen, setIsChatWindowOpen] = useState(false);
  const [conversation, setConversation] = useState<Conversation | null>(null);
  const [messages, setMessages] = useState<Message[]>([]);
  const [hasUnreadMessages, setHasUnreadMessages] = useState(false);
  const [chatClient, setChatClient] = useState<any>();
  const [sessionId, setSessionId] = useState<string | undefined>();

  const connect = useCallback(
    (token: string) => {
      setSessionId(token);
      Client.create(token)
        .then(client => {
          //@ts-ignore
          window.chatClient = client;
          setChatClient(client);
        })
        .catch(() => {
          onError(new Error('There was a problem connecting to My conversation service.'));
        });
    },
    [onError]
  );

  const disconnect = async () => {
    await Client.disconnect();
  };

  useEffect(() => {
    if (conversation) {
      // メッセージ受領イベントハンドリング
      const handleMessageAdded = (message: Message) => {
        setMessages(oldMessages => [...oldMessages, message]);
      };
      // ソケット切断イベントハンドリング
      /*const handleSocketClosed = () => {
        return sessionId && connect(sessionId);
      };*/
      // ソケットエラーイベントハンドリング
      /*const handleSocketError = () => {
        onError(new Error('There was a problem connecting to My conversation service.'));
      };*/
      conversation.getMessages().then(newMessages => setMessages(newMessages.items));
      conversation.on('messageAdded', handleMessageAdded);
      //conversation.on('socketClosed', handleSocketClosed);
      //conversation.on('socketError', handleSocketError);
      return () => {
        conversation.off('messageAdded', handleMessageAdded);
        //conversation.off('socketClosed', handleSocketClosed);
        //conversation.off('socketError', handleSocketError);
      };
    }
  }, [conversation, connect, sessionId, onError]);

  useEffect(() => {
    // If the chat window is closed and there are new messages, set hasUnreadMessages to true
    if (!isChatWindowOpenRef.current && messages.length) {
      setHasUnreadMessages(true);
    }
  }, [messages]);

  useEffect(() => {
    isChatWindowOpenRef.current = isChatWindowOpen;
    if (isChatWindowOpen) setHasUnreadMessages(false);
  }, [isChatWindowOpen]);

  useEffect(() => {
    if (room && chatClient) {
      chatClient
        .getConversationByUniqueName(room)
        //@ts-ignore
        .then(newConversation => {
          //@ts-ignore
          window.chatConversation = newConversation;
          setConversation(newConversation);
        })
        .catch(() => {
          onError(new Error('There was a problem getting the Conversation associated with this room.'));
        });
    }
  }, [room, chatClient, onError]);

  return (
    <ChatContext.Provider
      value={{ isChatWindowOpen, setIsChatWindowOpen, connect, disconnect, hasUnreadMessages, messages, conversation }}
    >
      {children}
    </ChatContext.Provider>
  );
};
